
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppWithRoutes from './AppWithRoutes';
import { UserProvider } from './components/context/UserContext';
import Sidebar from './components/sidebar/sidebar';


export default function App() {
  return (
    <div>

      <UserProvider>
        <AppWithRoutes>

        </AppWithRoutes>

      </UserProvider>

    </div>
  );
}
